<template>
  <div>
    <breadcrumb-bar :crumbs="[{name:'Administrative Settings'},{name:'General Settings', link:'General Settings'}]" />

    <vue-spinner v-if="generalSettingsLoading" />
    <template v-else>
      <div class="row">
        <div class="col-md-6">
          <maintenance-mode :status="generalSettings.maintenance_mode" :message="generalSettings.maintenance_message" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import MaintenanceMode from "./GeneralSettings/MaintenanceMode";
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from 'vuex'

  export default {

    data() {
      return {
      }
    },
    components: {
      'breadcrumb-bar': Breadcrumbs,
      'vue-spinner': Spinner,
      MaintenanceMode
    },
    computed: {
      ...mapGetters({
        generalSettingsLoading: 'getGeneralSettingsLoading',
        generalSettings: 'getGeneralSettings'
      }),
    },
    methods: {
      ...mapActions({
        getGeneralSettingsAction: 'loadGeneralSettings'
      })
    },
    created() {
      this.getGeneralSettingsAction();
    }
  }
</script>



// WEBPACK FOOTER //
// GeneralSettings.vue?54b3d754